import type { DpiaRequest } from 'config/api/dpiaRequests/dpiaRequests.types';
import type { DpiaSourceRequestSummary } from 'config/api/dpias/dpias.types';

export type DpiaTriggerSummary = {
  triggerSource: string | null;
  triggerComment: string;
};

export const resolveDpiaTrigger = (
  sourceRequest?: Pick<DpiaSourceRequestSummary, 'triggerSource' | 'triggerComment'> | null,
  request?: Pick<DpiaRequest, 'triggerSource' | 'triggerComment'> | null,
): DpiaTriggerSummary | null => {
  const triggerSource = sourceRequest?.triggerSource || request?.triggerSource || null;
  const triggerComment = sourceRequest?.triggerComment || request?.triggerComment || '';

  if (!triggerSource && !triggerComment) {
    return null;
  }

  return { triggerSource, triggerComment };
};

export default resolveDpiaTrigger;
